module.exports = __webpack_public_path__ + "static/media/twitter_icon.f489df17.JPG";